import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import renderHTML from 'react-render-html';
import { isMobile } from '../../../utils/adaptive';
import { getViewport, generateImageUrl } from '../../../utils/webp';

import { TitleImage } from '../../title-image';

import {
  Container,
  InputWrapper,
  SignupBtn,
  FlexRow,
} from '../styles/signup.style';
import { Section, RTE } from '../../../utils/atoms';
import FooterItem from '../../footer/components/footer-item';
import { FooterRow } from '../../footer/styles/footer.style';

/**
 * Signup Page Component
 */
class SignupPage extends React.Component {
  /**
   * Signup constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResponse = this.handleResponse.bind(this);

    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      error: '',
      reCAPTCHA: false,
      submitted: false,
      isMobileLocal: false,
      viewportWidth: 2400,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({ viewportWidth: getViewport() });
    }
  }

  /**
   * Sets mobile state if applicable
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ isMobileLocal: true });
    }
  }

  /**
   * Sets state of successful call
   * @param {object} value Response object
   */
  onChange(value) {
    this.setState({ reCAPTCHA: value });
  }

  // /**
  //  * Logs out error
  //  * @param {object} e Error object
  //  */
  // onError(e) {
  //   console.error('Captcha Error', e);
  // }

  /**
   * Sets state on key change
   * @param {object} event Event listener
   * @param {string} valueType type of input value
   */
  handleChange(event, valueType) {
    this.setState({ [valueType]: event.target.value });
  }

  /**
   * Sets state of successful call
   * @param {object} res Response object
   */
  handleResponse(res) {
    if (res.statusCode === 201) {
      this.setState({ submitted: true });
    } else {
      this.setState({ error: res.statusMessage });
    }
  }

  /**
   * Handles submit of the signup form
   * @param {object} event Submit event
   */
  handleSubmit(event) {
    event.preventDefault();
    const {
      email,
      firstName,
      lastName,
      reCAPTCHA,
    } = this.state;

    const {
      cityReference,
      apiUrl,
      tag,
      segment,
    } = this.props;
    const cityName = cityReference ? cityReference.cityName : '';
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(email)) {
      this.setState({ error: 'No good! Please enter a valid email.' });
      return;
    }
    if (!firstName) {
      this.setState({ error: 'Please enter your First Name.' });
      return;
    }
    if (!lastName) {
      this.setState({ error: 'Please enter your Last Name.' });
      return;
    }

    if (reCAPTCHA) {
      fetch(apiUrl, {
        method: 'post',
        cache: 'no-cache',
        body: JSON.stringify({
          email_address: email,
          status: 'subscribed',
          merge_fields: {
            FNAME: firstName,
            LNAME: lastName,
            CITYPREF: cityName,
            tag,
          },
          segments: {
            static_segment: segment,
          },
        }),
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      })
        .then(response => response.json())
        .then((response) => {
          if (response.status === 'subscribed') {
            this.setState({ submitted: true });
          } else if (response.status === 400) {
            if (response.title === 'Member Exists') {
              this.setState({ error: "Looks like you're already signed up." });
            } else {
              this.setState({ error: 'Opps! There was a problem.' });
            }
          } else {
            this.setState({ error: 'Opps! There was a problem.' });
          }
        });
    } else {
      this.setState({ error: 'Please complete the reCAPTCHA' });
    }
  }

  /**
   * Renders the Signup gorm
   * @returns {XML} Signup component
   */
  render() {
    let formContent;
    const {
      submitted, email, error, firstName, lastName, isMobileLocal, viewportWidth,
    } = this.state;
    const {
      titleImage,
      subtitle,
      childContentfulSignUpDescriptionTextNode,
      placeholderEmail,
      placeholderFirstName,
      placeholderLastName,
      buttonText = 'SUBMIT',
      background,
    } = this.props;

    const placeholderEmailText = placeholderEmail || 'Enter your email address';
    const placeholderFirstNameText = placeholderFirstName || 'Enter your email address';
    const placeholderLastNameText = placeholderLastName || 'Enter your email address';

    const description = childContentfulSignUpDescriptionTextNode;
    const url = background && background.file && background.file.url;
    const html = description && description.childMarkdownRemark && description.childMarkdownRemark.html;
    if (submitted) {
      formContent = (
        <form className="xfl-signup__form" id="signup">
          { 'Congratulations. You’re on the team.' }
        </form>
      );
    } else {
      formContent = (
        <form className="xfl-signup__form" id="signup">
          <FooterRow className="footer-row--small footer-row--light footer-row--top-gap">
            <FooterItem text="Terms &amp; Conditions" target="/termsandconditions" newWindow primary />
            <FooterItem text="Privacy Policy" target="/privacypolicy" newWindow primary />
          </FooterRow>
          <FlexRow>
            <InputWrapper>
              <input
                type="text"
                value={email}
                onChange={event => this.handleChange(event, 'email')}
                aria-label={placeholderEmailText}
                placeholder={placeholderEmailText}
              />
              <input
                type="text"
                value={firstName}
                onChange={event => this.handleChange(event, 'firstName')}
                aria-label={placeholderFirstNameText}
                placeholder={placeholderFirstNameText}
                className="input-name"
              />
              <input
                type="text"
                value={lastName}
                onChange={event => this.handleChange(event, 'lastName')}
                aria-label={placeholderLastNameText}
                placeholder={placeholderLastNameText}
                className="input-name"
              />
            </InputWrapper>
            <SignupBtn
              to="#"
              onClick={(e) => {
                this.handleSubmit(e);
              }}
            >
              <span>{buttonText}</span>
            </SignupBtn>
          </FlexRow>
          <ReCAPTCHA
            sitekey="6LdJ43EUAAAAAOt0SvRdiYw3Ldll6Viu-2XD3pDj"
            className="xfl-signup__captcha"
            onChange={this.onChange}
            onErrored={this.onError}
            onExpired={this.onExpired}
            size={isMobileLocal ? 'compact' : 'normal'}
          />
          <span className="error" id="">
            {error}
          </span>
        </form>
      );
    }
    return (
      <Section background={generateImageUrl(url, viewportWidth)} position="top right">
        <Container>
          <h1>
            <TitleImage src={titleImage && titleImage.file && titleImage.file.url} alt="Sign Up" />
          </h1>
          <h2>{subtitle}</h2>
          {html && (
            <div className="content-html">
              <RTE>
                {renderHTML(html)}
              </RTE>
            </div>
          )}

          {formContent}
        </Container>
      </Section>
    );
  }
}

export default SignupPage;



// WEBPACK FOOTER //
// ./src/components/sign-up/components/signup.js